import { render, staticRenderFns } from "./CRUDLinhas.vue?vue&type=template&id=9b8971f0&"
import script from "./CRUDLinhas.vue?vue&type=script&lang=js&"
export * from "./CRUDLinhas.vue?vue&type=script&lang=js&"
import style0 from "./CRUDLinhas.vue?vue&type=style&index=0&id=9b8971f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports